@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
<div
  class="projectable-form-wrapper frontdoor-form share-form-page"
  (keyup.enter)="save($event)"
  (keyup.escape)="closeModal(false)"
  >
  <lib-form-header
    [data]="formData"
    [title]="isExistingEntity ? 'View TCP Share: ' : 'Create New TCP Share'"
    [moreActions]="moreActions"
    (actionRequested)="headerActionRequested($event)"
    [(formView)]="formView"
  ></lib-form-header>
  <div class="integration-form-container projectable-form-container">
    @if (formView === 'simple') {
      <div class="share-layout">
        <div class="share-row">
          <div class="form-group-column half">
            <lib-form-field-container [title]="'Share Details'">
              <div class="stacked-fields">
                <div class="field-row frontdoor-error-stack" [class.frontdoor-error-field]="nameError">
                  <div class="field-label">
                    <span class="frontdoor-inline-error-group">
                      Share Name
                      <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="nameError">
                        {{ nameErrorMessage || 'Must not be blank' }}
                      </span>
                    </span>
                    <span class="field-label-suffix">REQUIRED</span>
                  </div>
                  <input
                    class="form-field-input"
                    placeholder="Add your share name."
                    [ngClass]="{error: errMap['domainName'] || errMap['nameRequired']}"
                    [(ngModel)]="formData.name"
                    autofocus
                    #nameFieldInput
                  />
                </div>

                <div class="field-row frontdoor-error-stack" [class.frontdoor-error-field]="agentError">
                  <div class="field-label">
                    <span class="frontdoor-inline-error-group">
                      Hosting Frontdoor Agent
                      <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="agentError">
                        {{ agentErrorMessage || 'Select an agent' }}
                      </span>
                    </span>
                    <span class="field-label-suffix">REQUIRED</span>
                  </div>
                  <app-filter-select
                    [options]="agentList"
                    [(ngModel)]="formData.envId"
                    placeholder="Select an Agent"
                    optionValue="zId"
                    optionLabel="description"
                    style="color: var(--tableText)"
                  >
                  </app-filter-select>
                </div>

                <div class="field-row frontdoor-error-stack" [class.frontdoor-error-field]="targetError">
                  <div class="field-label">
                    <span class="frontdoor-inline-error-group">
                      Target
                      <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="targetError">
                        {{ targetErrorMessage || 'Must not be empty' }}
                      </span>
                    </span>
                    <span class="field-label-suffix">REQUIRED</span>
                  </div>
                  <input
                    class="form-field-input"
                    placeholder="Add target for your share."
                    [ngClass]="{error: errMap['description'] || errMap['nameRequired']}"
                    [(ngModel)]="formData.target"
                  />
                </div>

                <div class="field-row frontdoor-error-stack" [class.frontdoor-error-field]="IngressPortError">
                  <div class="field-label">
                    <span class="frontdoor-inline-error-group">
                      Ingress Port
                      <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="IngressPortError">
                        {{ IngressPortMessage || 'Enter an ingress port' }}
                      </span>
                    </span>
                    <span class="field-label-suffix">REQUIRED</span>
                  </div>
                  <input
                    type="number"
                    min="2100"
                    max="2199"
                    [(ngModel)]="formData.ingressPort"
                    placeholder="Must be a value between 2100 and 2199"
                  />
                </div>
              </div>
            </lib-form-field-container>
          </div>

          <div class="form-group-column half">
            <lib-form-field-container [title]="'Client Type & Certificate'">
              <div class="stacked-fields">
                <div class="field-row">
                  <div class="field-label">Certificate Type</div>
                  <app-filter-select
                    [options]="certificateTypes"
                    placeholder="Select a Certificate Type"
                    [ngModel]="selectedCertificate"
                    (ngModelChange)="onCertificateTypeChange($event)"
                  >
                  </app-filter-select>
                </div>

                @if (selectedCertificate === 'Client Certificate') {
                  <div class="field-row frontdoor-error-stack" [class.frontdoor-error-field]="clientCertError">
                    <div class="field-label">
                      <span class="frontdoor-inline-error-group">
                        Client Certificate
                        <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="clientCertError">
                          {{ clientCertErrorMessage || 'Client certificate is required' }}
                        </span>
                      </span>
                      <span class="field-label-suffix">REQUIRED</span>
                    </div>
                    <app-filter-select
                      [options]="clientCertificateList"
                      [(ngModel)]="formData.clientCertificateId"
                      placeholder="Select a Client Certificate"
                      optionValue="id"
                      optionLabel="name"
                    >
                      <ng-template appFilterSelectFooter>
                        <app-button
                          type="button"
                          styleClass="w-full"
                          icon="pi pi-plus"
                          label="Add New Client Certificate"
                          style="background-color: var(--primaryColor)"
                          (click)="addClientCertificate()"
                        >
                        </app-button>
                      </ng-template>
                    </app-filter-select>
                  </div>
                }

                @if (selectedCertificate === 'System Generated Certificate') {
                  <div class="field-row">
                    <div class="field-label">
                      Allowed Subjects
                      <span class="field-label-suffix">OPTIONAL</span>
                    </div>
                    <app-chips-input
                      (keydown)="onKeyDown($event)"
                      [allowDuplicate]="false"
                      [placeholder]="'Example: CN=service-account-1,O=MyCompany'"
                      addOnBlur="true"
                      separator=","
                      [disabled]="formData.clientCertificateId || isEditing"
                      [(ngModel)]="formData.allowedSubjects"
                      (paste)="paste($event)"
                    >
                    </app-chips-input>
                  </div>

                  <div class="field-row">
                    <div class="field-label">
                      Allowed Common Name Prefixes
                      <span class="field-label-suffix">OPTIONAL</span>
                    </div>
                    <app-chips-input
                      (keydown)="onKeyDown($event)"
                      [allowDuplicate]="false"
                      [disabled]="formData.clientCertificateId || isEditing"
                      [placeholder]="'Example: service-account-;frontdoor-access-;example-'"
                      addOnBlur="true"
                      [(ngModel)]="formData.allowedCommonNamePrefixes"
                      separator=","
                      (paste)="paste($event)"
                    >
                    </app-chips-input>
                  </div>

                  <div class="field-row">
                    <div class="field-label">
                      Organizational Unit
                      <span class="field-label-suffix">OPTIONAL</span>
                    </div>
                    <input
                      [(ngModel)]="formData.organizationalUnit"
                      placeholder="Allow only a specific organization unit"
                      [disabled]="isEditing"
                    />
                  </div>
                }
              </div>
            </lib-form-field-container>
          </div>
        </div>
      </div>
    }
    @if (formView === 'raw') {
      <div class="form-group-column">
        @if (formData) {
          <lib-json-view [(data)]="formData"></lib-json-view>
        }
      </div>
    }

  </div>
